module.exports = __webpack_public_path__ + "e8a8f217999b069599dc0c14519686d2.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/icons/build/fonts/spark-icon-line.woff
// module id = 1406
// module chunks = 0